module.exports = __webpack_public_path__ + "static/media/Bus.c11f0deb.png";